/**
 * AgentBadge Component
 * Displays a badge indicating which AI agent is active
 */

import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { AGENT_INFO, type AgentType } from "@/types/chat.types";

interface AgentBadgeProps {
  type: AgentType;
  showTooltip?: boolean;
}

export const AgentBadge = ({ type, showTooltip = true }: AgentBadgeProps) => {
  const info = AGENT_INFO[type];

  if (!info) return null;

  const badge = (
    <Badge variant={info.badgeVariant} className="text-xs">
      {info.label}
    </Badge>
  );

  if (!showTooltip) {
    return badge;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{badge}</TooltipTrigger>
        <TooltipContent>
          <p className="text-sm">{info.description}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
